import { configureStore } from "@reduxjs/toolkit";
import notificationsReducer from "./notifications";
import statisticsReducer from "./statistics";
import { saveState, loadState } from "../helper";

const preloadedState = loadState();

const store = configureStore({
  reducer: {
    notifications : notificationsReducer,
    statistics : statisticsReducer,
  },
  preloadedState, 
});

store.subscribe(() => {
  saveState({
    notifications: store.getState().notifications,
    statistics: store.getState().statistics,
  });
});

export default store;
